import { NavLink } from "react-router-dom";
import { publicUrlFor } from "../../../globals/constants";
import { useLangagesStore } from "../../../context/langages";
import { data as dataEs } from "../../../globals/data/es/footer";
import { data as dataEn } from "../../../globals/data/en/footer";
import { data as dataCn } from "../../../globals/data/zh/footer";

export default function Footer1() {
  const langage = useLangagesStore((state) => state.langage);

  const data = langage === "en" ? dataEn : langage === "cn" ? dataCn : dataEs;

  return (
    <>
      <footer className="footer-light">
        {/* NEWS LETTER SECTION START */}
        {/*  <div className="ftr-nw-ltr site-bg-white">
                <div className="ftr-nw-ltr-inner site-bg-primary">
                    <div className="container">
                        <div className="ftr-nw-img">
                            <img src={publicUrlFor("/assets/images/news-l-bg.png")} alt="#" />
                        </div>
                        <div className="ftr-nw-content">
                            <div className="ftr-nw-title">Subscribe for offers and news</div>
                            <div className="ftr-nw-form">
                                <form>
                                    <input name="news-letter" className="form-control" placeholder="Enter Your Email" type="text" />
                                    <button className="ftr-nw-subcribe-btn">Subscribe Now</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
        {/* NEWS LETTER SECTION END */}

        <div className="ftr-bg mt-5">
          <div
            className="ftr-nw-ltr-inner site-bg-primary"
            style={{ height: "2px" }}
          ></div>
          {/* FOOTER BLOCKES START */}
          <div className="footer-top">
            <div className="container">
              <div className="row">
                <div className="col-lg-3 col-md-6">
                  <div className="widget widget_about">
                    <div className="logo-footer clearfix">
                      <NavLink to="/index">
                        <img
                          src={publicUrlFor(
                            "/assets/images/LOGO_ASEMARINSA.webp"
                          )}
                          alt="#"
                        />
                      </NavLink>
                    </div>
                    <p className="text-justify">{data.description}</p>
                    <p className="text-justify">{data.address}</p>
                    <ul className="social-icons">
                      <li>
                        <a
                          href="https://www.facebook.com/people/Asemarinsa/100051055310721"
                          className="fa fa-facebook"
                        >
                          {" "}
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.instagram.com/asemarinsa"
                          className="fa fa-instagram"
                        >
                          {" "}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="widget widget_services ftr-list-center">
                    <h3 className="widget-title">{data.quick}</h3>
                    <ul>
                      <li>
                        <NavLink to="/about-us">{data.aboutUs}</NavLink>
                      </li>
                      <li>
                        <NavLink to="/contact-us">{data.contactUs}</NavLink>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6">
                  <div className="widget widget_services ftr-list-center">
                    <h3 className="widget-title">{data.services}</h3>
                    <ul>
                      <li>
                        <NavLink to="/services/maritime-law">
                          {data.maritimeLaw}
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/services/tax-law">{data.taxLaw}</NavLink>
                      </li>
                      <li>
                        <NavLink to="/services/customs-law">
                          {data.customsLaw}
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/services/commercial-law">
                          {data.commercialLaw}
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/services/insurance">
                          {data.insurance}
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/services/administrative-processes">
                          {data.administrativeProcesses}
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/services/operations-sts">
                          {data.stsOperations}
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6">
                  <div className="widget widget_services ftr-list-center">
                    <h3 className="widget-title">{data.community}</h3>
                    <ul>
                      <li>
                        <NavLink to="/privacy-policy">{data.privacyPolicy}</NavLink>
                      </li>
                      <li>
                        <NavLink to="/terms-conditions-use">
                          {data.termsAndConditions}
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* FOOTER COPYRIGHT */}

          <div className="footer-bottom">
            <div className="container">
              <div className="footer-bottom-info">
                <div className="footer-copy-right">
                  <span className="copyrights-text">
                    Copyright © 2025 ASEMARINSA. All Rights Reserved.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
